import React from 'react';

/* @Hooks */
import { useIntl } from 'react-intl';

export const LoadingComponent = () => {
  const { formatMessage: trans } = useIntl();

  return <h1>{trans({ id: 'loading' })}</h1>;
};
